export default __webpack_public_path__ + "static/media/dual_purpose_millet.8fdf274d.jpg";